import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";

export default function NotFound() {
  return (
    <PageLayout>
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-20 text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-accent-100 flex items-center justify-center">
          <i className="ri-error-warning-line text-3xl text-accent-600"></i>
        </div>
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">404</h1>
        <p className="text-foreground-600 mb-8">抱歉，您访问的页面不存在</p>
        <Link to="/" className="inline-flex items-center px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
          <i className="ri-home-line mr-1.5"></i>返回首页
        </Link>
      </div>
    </PageLayout>
  );
}